import React from 'react';
import {
    ActivityTableReport,
    BalanceCard,
    CryptoCard, CryptoList,
    GraphArea,
    HeaderArea, Loader,
} from "@/components";
import {useQuery} from "@tanstack/react-query";
import {ApiResponse} from "@/types/Api.tsx";
import {CryptoStats} from "@/types/Currency.tsx";
import GenericApi from "@/api/genericApi.tsx";
import {ApiRoutes} from "@/config/routes/ApiRoutes.tsx";
import {CryptoStatsQueryKey,} from "@/config/constants/QueryKeys.tsx";

const MyDashboard: React.FC = () => {

    const { data: cryptoStats, isLoading } = useQuery<ApiResponse<CryptoStats[]>>({
        queryFn: async () => GenericApi.get<CryptoStats[]>(ApiRoutes.CRYPTO_STATS),
        queryKey: [CryptoStatsQueryKey],
    });

    if(isLoading) {
        return <Loader />
    }

    if(!cryptoStats || !cryptoStats.data || cryptoStats?.error) {
        return <div className='text-black'>No data</div>
    }



    return (
        <div className="mb-20">
            <HeaderArea />
            <BalanceCard />

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
                <div className="lg:col-span-2 h-full">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                        {
                            cryptoStats?.data?.map((cryptoStat, index) => (
                                <CryptoCard
                                    key={index}
                                    cryptoStat={cryptoStat}
                                />
                            ))
                        }
                    </div>

                    <div className="mt-6 h-full">
                        <GraphArea />
                    </div>
                </div>

                <div className="lg:col-span-1 h-full">
                    <CryptoList />
                    {/*<MemoizedWatchList />*/}
                </div>

                <div className="lg:col-span-3">
                    <ActivityTableReport isReport={false}/>
                </div>
            </div>
        </div>
    );
};

export default MyDashboard;